import './LoginScreen.css'

export class LoginScreen {
  constructor(authManager, onSuccess) {
    this.auth      = authManager
    this.onSuccess = onSuccess
    this.el        = null
    this.activeTab = 'login'
  }

  show() {
    this.el = document.createElement('div')
    this.el.id = 'LoginOverlay'
    this.el.innerHTML = `
      <div id="LoginPanel">
        <div class="login-title">TOWER DEFENSE</div>
        <div class="login-subtitle">Sign in to save your progress</div>
        <div class="login-tabs">
          <button class="login-tab active" data-tab="login">LOGIN</button>
          <button class="login-tab" data-tab="register">REGISTER</button>
        </div>
        <div class="login-fields">
          <input id="LoginUser" type="text" placeholder="Username" maxlength="60" autocomplete="off" spellcheck="false">
          <input id="LoginPass" type="password" placeholder="Password" autocomplete="off">
          <div id="LoginError" class="login-error"></div>
          <button id="LoginSubmit" class="login-submit">LOGIN</button>
        </div>
        <button id="LoginGuest" class="login-guest">Continue as Guest</button>
      </div>
    `
    document.body.appendChild(this.el)
    this._bindEvents()
    // Focus username field
    setTimeout(() => document.getElementById('LoginUser')?.focus(), 50)
  }

  _bindEvents() {
    // Tab switching
    this.el.querySelectorAll('.login-tab').forEach(btn => {
      btn.addEventListener('click', () => {
        this.activeTab = btn.dataset.tab
        this.el.querySelectorAll('.login-tab').forEach(b => b.classList.remove('active'))
        btn.classList.add('active')
        document.getElementById('LoginSubmit').textContent = this.activeTab === 'login' ? 'LOGIN' : 'REGISTER'
        document.getElementById('LoginError').textContent  = ''
      })
    })

    // Submit
    document.getElementById('LoginSubmit').addEventListener('click', () => this._submit())

    // Enter key
    this.el.addEventListener('keydown', e => { if (e.key === 'Enter') this._submit() })

    // Guest
    document.getElementById('LoginGuest').addEventListener('click', () => {
      this._dismiss()
      this.onSuccess(null)
    })
  }

  async _submit() {
    const username = document.getElementById('LoginUser').value.trim()
    const password = document.getElementById('LoginPass').value
    const errEl    = document.getElementById('LoginError')
    const btn      = document.getElementById('LoginSubmit')

    if (!username || !password) {
      errEl.textContent = 'Please enter a username and password.'
      return
    }

    btn.disabled    = true
    btn.textContent = '...'
    errEl.textContent = ''

    try {
      let user
      if (this.activeTab === 'login') user = await this.auth.login(username, password)
      else                            user = await this.auth.register(username, password)
      this._dismiss()
      this.onSuccess(user)
    } catch (e) {
      errEl.textContent   = e.message
      btn.disabled        = false
      btn.textContent     = this.activeTab === 'login' ? 'LOGIN' : 'REGISTER'
    }
  }

  _dismiss() {
    this.el?.remove()
    this.el = null
  }
}